export default __webpack_public_path__ + "static/media/Ascent Yarns Private Limited .00ef5c6a.jpg";